module.exports = __webpack_public_path__ + "img/titel.67c42a86.jpg";